export default __webpack_public_path__ + "static/media/background-2.68a09e43.svg";